import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import CloseIcon from "@mui/icons-material/Clear";
import MinimiseIcon from "@mui/icons-material/Remove";
import MaximiseIcon from "@mui/icons-material/Launch";

import IconButton from "@mui/material/IconButton";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";

import {
  hideModal,
  minimiseModal,
  maximiseModal,
  selectIsMinimised,
  selectIsMaximised
} from "~/store/ducks/domain/ui/modal";

const StyledDialogTitle = styled(DialogTitle)({
  position: "relative",
  margin: 0,
  padding: 0,
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "space-between"
});

const StyledTypography = styled(Typography, {
  shouldForwardProp: prop => prop !== "isMinimised"
})(({ isMinimised }) => ({
  display: isMinimised ? "inline" : "block",
  padding: "12px 16px"
}));

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  fontSize: theme.typography.h6.htmlFontSize,
  "&:focus-visible": {
    outline: theme.outline(),
    outlineOffset: "-2px"
  }
}));

function DialogHeader({ title, isMaximised, isMinimised, maximiseModal, minimiseModal, hideModal, isCloseableOnly }) {
  return (
    <StyledDialogTitle>
      <StyledTypography variant="h6" isMinimised={isMinimised}>
        {title}
      </StyledTypography>
      <div>
        {!isCloseableOnly && isMinimised && (
          <StyledIconButton onClick={maximiseModal} size="large" aria-label="Maximieren">
            <MaximiseIcon />
          </StyledIconButton>
        )}

        {!isCloseableOnly && isMaximised && (
          <StyledIconButton onClick={minimiseModal} size="large" aria-label="Minimieren">
            <MinimiseIcon />
          </StyledIconButton>
        )}

        <StyledIconButton onClick={hideModal} size="large" aria-label="Schließen">
          <CloseIcon />
        </StyledIconButton>
      </div>
    </StyledDialogTitle>
  );
}

DialogHeader.propTypes = {
  title: PropTypes.string,
  isMaximised: PropTypes.bool.isRequired,
  isMinimised: PropTypes.bool.isRequired,
  maximiseModal: PropTypes.func.isRequired,
  minimiseModal: PropTypes.func.isRequired,
  hideModal: PropTypes.func.isRequired,
  isCloseableOnly: PropTypes.bool
};

function mapStateToProps(state) {
  return {
    isMaximised: selectIsMaximised(state),
    isMinimised: selectIsMinimised(state)
  };
}

const mapDispatchToProps = {
  hideModal,
  minimiseModal,
  maximiseModal
};

export default connect(mapStateToProps, mapDispatchToProps)(DialogHeader);
